// extracted by mini-css-extract-plugin
module.exports = {"siteFooter":"footer-module--siteFooter--Ud9C7","sub":"footer-module--sub--2xsSm"};